<app-modal [header]="'global.label.edit' | translate">
  <div modal-body class="h-100 d-flex gap-3">

    <form>
      <b class="d-block mb-2">{{ 'complexArticleBlueprint.label.properties' | translate }}</b>

      <div class="row mb-2">
        <div class="form-group col-md-6">
          <label for="name" class="form-label">{{ 'complexArticleBlueprint.label.name' | translate }}</label>
          <input (change)="reValidate()" [(ngModel)]="blueprint.name" name="name" id="name" class="form-control" type="text">
        </div>

        <div class="form-group col-md-6">
          <label for="description" class="form-label">{{ 'complexArticleBlueprint.label.description' | translate }}</label>
          <input name="description" id="description" class="form-control" type="text" (change)="reValidate()" [(ngModel)]="blueprint.description">
        </div>
      </div>

      <div class="row mb-2">
        <div class="form-group col-md-6">
          <label for="saveFolder" class="form-label">{{ 'complexArticleBlueprint.label.save_folder' | translate }}</label>
          <div class="d-flex">
            <span style="width: 250px;" class="form-control text-truncate" type="number">{{projectGroupName}}</span>
            <button (click)="selectProjectGroup()" class="btn btn-secondary btn-sm" data-testid="select-project-group">
              <app-svg-icon type="folder"/>
            </button>
          </div>
        </div>

        @if (allArticleTypes(); as allArticleTypes) {
          <div class="form-group col-md-6">
            <label for="articleTypeId" class="form-label">{{ 'complexArticleBlueprint.label.articleTypeId' | translate }}</label>
            <select
              (change)="reValidate()" [(ngModel)]="blueprint.articleTypeId"
              id="articleTypeId"
              name="articleTypeId"
              class="form-control"
            >
              @for (articleType of allArticleTypes; track $index) {
                <option [ngValue]="articleType.id">{{ articleType.displayName }} ({{articleType.id}})</option>
              }
            </select>
          </div>
        }
      </div>

      <div class="row mb-2">
        <div class="col-md-6">
          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.flags.isIndividualPartsStickTogether" type="checkbox" class="form-check-input" name="individualsStickTogether"
                   id="individualsStickTogether">
            <label class="form-check-label" for="individualsStickTogether">{{ 'save.label.composite_article_stick_together' | translate }}</label>
          </div>

          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.flags.isIndividualPartsModifiable" type="checkbox" class="form-check-input" name="individualsModifiable"
                   id="individualsModifiable">
            <label class="form-check-label" for="individualsModifiable">{{ 'save.label.composite_part_modification' | translate }}</label>
          </div>

          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.flags.isIndividualPartsSelectable" type="checkbox" class="form-check-input" name="individualsSelectable"
                   id="individualsSelectable">
            <label class="form-check-label" for="individualsSelectable">{{ 'save.label.composite_part_selection' | translate }}</label>
          </div>

        </div>

        <div class="col-md-6">
          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.flags.isInitialRotationRequired" type="checkbox" class="form-check-input" name="individualsRotationRequired"
                   id="individualsRotationRequired">
            <label class="form-check-label" for="individualsRotationRequired">{{ 'save.label.composite_article_apply_initial_rotation' | translate }}</label>
          </div>
          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.saveMode" [value]="SaveAsCompositeMode.ARTICLE" type="radio" class="form-check-input" name="saveMode"
                   id="saveModeA">
            <label class="form-check-label" for="saveModeA">{{ 'complexArticleBlueprint.label.as_article' | translate }}</label>
          </div>

          <div class="mb-2 form-check">
            <input (change)="reValidate()" [(ngModel)]="blueprint.saveMode" [value]="SaveAsCompositeMode.BUILDING_BLOCK" type="radio" class="form-check-input" name="saveMode"
                   id="saveModeB">
            <label class="form-check-label" for="saveModeB">{{ 'complexArticleBlueprint.label.as_building_block' | translate }}</label>
          </div>

          @if(blueprint.saveMode == SaveAsCompositeMode.BUILDING_BLOCK) {
            <div class="form-group col-md-6">
              <label for="buildingBlockName" class="form-label">{{ 'complexArticleBlueprint.label.building_block_name' | translate }}</label>
              <input (change)="reValidate()" [(ngModel)]="blueprint.buildingBlockName" name="buildingBlockName" id="buildingBlockName" class="form-control" type="text">
              <a class="link small pb-2 ps-2" [href]="'complexArticleBlueprint.link.articleNoSchema' | translate" target="_blank">
                <app-svg-icon type="question_circle" inline="true" class="me-1"/>
                {{ 'global.label.help' | translate }}
              </a>
            </div>
          }

        </div>
      </div>


      <b class="d-block mb-2">
        {{ 'complexArticleBlueprint.label.article_no_system' | translate }}
        <a class="link small pb-2 ps-2" [href]="'complexArticleBlueprint.link.articleNoSchema' | translate" target="_blank">
          <app-svg-icon type="question_circle" inline="true" class="me-1"/>
          {{ 'global.label.help' | translate }}
        </a>
      </b>

      <div class="d-flex gap-2">

        <div class="form-group mb-2">
          <label for="articleNumberSchema" class="form-label">{{ 'complexArticleBlueprint.label.article_no_system.schema' | translate }}</label>
          <input
            name="articleNumberSchema"
            id="articleNumberSchema"
            class="form-control"
            type="text"
            (change)="reValidate()"
            [(ngModel)]="blueprint.articleNumberSchema.articleNumber"
            aria-describedby="seriesHelp"
          >
        </div>

        <div class="d-flex flex-column gap-2">
          <div class="d-flex gap-2">
            <div class="form-group mb-2">
              <label for="from" class="form-label">{{ 'complexArticleBlueprint.label.article_no_system.from' | translate }}</label>
              <input
                name="from"
                id="from"
                class="form-control"
                type="number"
                (change)="reValidate()"
                [(ngModel)]="blueprint.articleNumberSchema.from"
                aria-describedby="seriesHelp"
              >
            </div>
            <div class="form-group mb-2">
              <label for="to" class="form-label">{{ 'complexArticleBlueprint.label.article_no_system.to' | translate }}</label>
              <input
                name="to"
                id="to"
                class="form-control"
                type="number"
                (change)="reValidate()"
                [(ngModel)]="blueprint.articleNumberSchema.to"
                aria-describedby="seriesHelp"
              >
            </div>
          </div>

          <div class="d-flex gap-2">
            <div class="form-group mb-2">
              <label for="excluded" class="form-label">{{ 'complexArticleBlueprint.label.article_no_system.excluded' | translate }}</label>
              <input
                [placeholder]="'semicolon separated list'"
                name="excluded"
                id="excluded"
                class="form-control"
                [value]="blueprint.articleNumberSchema.excluded.join(';')"
                (change)="updateExcluded($event)"
                type="text"
              >
            </div>

            <div class="form-group mb-2">
              <label for="additional" class="form-label">
                <span>{{ 'complexArticleBlueprint.label.article_no_system.additional' | translate }}</span>
              </label>
              <input
                [placeholder]="'semicolon separated list'"
                name="additional"
                id="additional"
                class="form-control"
                [value]="blueprint.articleNumberSchema.additional.join(';')"
                (change)="updateAdditional($event)"
                type="text"
              >
            </div>
          </div>
        </div>

      </div>
      @let validationErrorsValue = validationErrors();
      @if (!validationErrorsValue.valid) {
        <div data-testid="validation-errors" class="alert alert-warning" style="white-space: pre-line">{{ validationErrorsValue.errorsText }}</div>
      }
    </form>

    <app-complex-article-blueprint-rules (update)="reValidate()" [(blueprint)]="blueprint"/>

  </div>

  <ng-container modal-footer>
    <button id="cancel" class="btn btn-secondary btn-cancel" type="button" (click)="cancel()">{{ 'global.label.cancel' | translate }}</button>
    <button id="save" class="btn btn-primary" (click)="save()">{{ 'global.label.save' | translate }}</button>
  </ng-container>
</app-modal>
